export const METRIC_DISPLAY_NAMES: Record<string, string> = {
  aiMlHiring: 'AI/ML Hiring',
  aiBudget: 'AI Budget',
  eventAttendance: 'Event Attendance',
  aiMlRelatedProjects: 'AI/ML Projects',
  organizationalMoves: 'Organizational Moves',
  aiMlProductPotential: 'AI/ML Product Potential'
};

export const getMetricDisplayName = (key: string): string => {
  return METRIC_DISPLAY_NAMES[key] || key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
};